import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreatePortalModal from '@modals/CreatePortalModal'

import PageContent from './components/PageContent'

const callbacks = (component: keyof typeof componentCallbacks, setState: Function) => {
  const componentCallbacks = {
    CreatePortalModal: {
      closeModal: () => setState({ showCreatePortalModal: false }),
      createPortal: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreatePortalModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreatePortalModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      showCreatePortalModal: () => setState({ showCreatePortalModal: true }),
      ...filterCallbacks,
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>

        <PageContent pageFilters={pageFilters} />

        <CreatePortalModal
        // @ts-expect-error TS2322
          callbacks={callbacks('CreatePortalModal', setState)}
          showModal={showCreatePortalModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
